import React, {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomTag, {atomTagSizes} from '@s-ui/react-atom-tag'
import Context from '@s-ui/react-context'
import MoleculeThumbnail, {moleculeThumbnailShape} from '@s-ui/react-molecule-thumbnail'
import {
  imageUrlAdapterImageTypes,
  imageUrlAdapterTransformTypes,
  useImageUrlAdapter
} from '@adv-mt/mt-hook-use-image-url-adapter'
import LeadPhoneCall, {leadPhoneCallSizes, leadPhoneCallTarget, leadPhoneCallType} from '@adv-mt/mt-lead-phone-call'
import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

const CardUserContent = ({
  adId,
  avatar,
  hasCriteoEvents = false,
  hasPhoneNumber = true,
  isLoggedUser,
  leadData = {},
  multiprovince = '',
  name = '',
  pageName,
  phone,
  province
}) => {
  const {i18n, domain} = useContext(Context)
  const config = domain.get('config')
  const USER_DEFAULT_AVATAR_URL = config.get('USER_DEFAULT_AVATAR_URL')
  const {USER_AVATAR_SIZE} = domain.get('config').get('COMMON')
  const {PRIVATE_CONTRACT_ID} = config.get('dealer')

  const getImagesUrlsAdapted = useImageUrlAdapter()

  const getAdaptedAvatar = () => {
    const {
      images: [{src: adaptedImageSource}]
    } = getImagesUrlsAdapted({
      images: [{src: avatar}],
      options: {
        imageWidth: USER_AVATAR_SIZE,
        imageType: imageUrlAdapterImageTypes.AVATAR,
        transformType: imageUrlAdapterTransformTypes.DEVICE_CROP
      }
    })

    return adaptedImageSource
  }

  const avatarSrc = avatar ? getAdaptedAvatar() : USER_DEFAULT_AVATAR_URL

  return (
    <div className="mt-CardUser-content">
      <div className="mt-CardUser-avatar">
        <MoleculeThumbnail src={avatarSrc} alt={name} shape={moleculeThumbnailShape.CIRCLED} />
      </div>
      <div className="mt-CardUser-info">
        <AtomTag label={i18n.t('COMMON_PRIVATE_USER')} size={atomTagSizes.SMALL} />
        <div className="mt-CardUser-title">
          <TitleBasic as={titleBasicTags.h2} size={titleBasicSizes.xs} title={name} secure />
        </div>
        {province && <p className="mt-CardUser-location">{province}</p>}
        {hasPhoneNumber && (
          <div className="mt-CardUser-phone">
            <LeadPhoneCall
              adId={adId}
              contractId={PRIVATE_CONTRACT_ID}
              hasCriteoEvents={hasCriteoEvents}
              isLoggedUser={isLoggedUser}
              multiprovince={multiprovince}
              pageName={pageName}
              phone={phone}
              size={leadPhoneCallSizes.small}
              target={leadPhoneCallTarget.vehicle}
              type={leadPhoneCallType.link}
              extendedLeadTrackingData={leadData}
            />
          </div>
        )}
      </div>
    </div>
  )
}

CardUserContent.displayName = 'CardUserContent'
CardUserContent.propTypes = {
  adId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  avatar: PropTypes.string,
  hasCriteoEvents: PropTypes.bool,
  hasPhoneNumber: PropTypes.bool,
  isLoggedUser: PropTypes.bool,
  name: PropTypes.string.isRequired,
  pageName: PropTypes.string,
  phone: PropTypes.string.isRequired,
  province: PropTypes.string,
  leadData: PropTypes.object,
  multiprovince: PropTypes.string
}

export default CardUserContent
